import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { JwtUtils } from '../../utils/jwt-utils';
import { RequestService, } from './request-service';

@Component({
  selector: 'app-verify-request',
  templateUrl: './verify-request.component.html',
  styleUrls: ['./verify-request.component.css'],
  standalone: false
})
export class VerifyRequestComponent {

  token?: string;
  isLinkExpired = false;
  wentWrong = false;
  success = false;
  alreadyVerified = false;
  errorMessage = 'Request not received'

  constructor(activatedRoute: ActivatedRoute, private router: Router, private verifyRequestService: RequestService) {
    activatedRoute.queryParams.subscribe(async params => {
      this.token = params['token'];

      if (!this.token) {
        this.router.navigate(['/']);
      } else {
        try {
          await this.verifyRequestService.verifyRequest(this.token).then(() => {
            this.success = true
          })
        } catch (error: any) {
          console.error(error);
          console.log('Error verifying request:', error?.error.status?.toString());
          this.errorMessage = error?.error?.message || 'Request not received';
          if (error?.status?.toString() == '409') {
            this.alreadyVerified = true;
          }
          this.wentWrong = true;
        }
      }

    });
  }

  toDashboard() {
    this.router.navigate(['/']);
  }
}